import { observer } from "mobx-react";
import { IValidationGroup } from "../../../../../../../hooks/validation-group/validation-group-hook";
import { FormFieldLine } from "../../../../../../../components/form-field-line/form-field-line";
import { Input } from "../../../../../../../components/inputs/input/input";
import EasyshipCredentialsStore from "../../../../stores/credentials/shipping/easyship-credentials-store";

interface IProps {
    credentialsStore: EasyshipCredentialsStore,
    vGroup: IValidationGroup,
}

const EasyshipCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <FormFieldLine
                required
                label='Easyship Api Key'
                key='api_key'
                note='Your Easyship Api Key'
            >
                <Input
                    value={credentialsStore.apiKey}
                    onChange={credentialsStore.setApiKey}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default EasyshipCredentials;
